import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Icon from '../icon/Icon';
import { THEME_COLORS } from '../colors';
const ButtonIcon = ({ iconPath, title, className, disabled, onClick, onClickLink, href, to, id, size, color = 'colorIcon', target, rel, isActive, isSquare, }) => {
    const getIconSize = (iconSize) => {
        if (iconSize === 'sm') {
            return '24px';
        }
        return '24px';
    };
    const cssContent = classNames('button-icon', size ? size : 'md', 'hover-' + color, { disabled: disabled }, isActive ? 'active-' + color : '', isSquare ? 'square' : '');
    const renderIcon = (React.createElement(Icon, { path: iconPath, color: color !== 'primitiveNavyBlue' ? THEME_COLORS[color] : undefined, size: getIconSize(size), title: undefined }));
    let iconContent;
    if (href) {
        iconContent = (React.createElement("a", { href: href, target: target, rel: rel, className: cssContent, id: id, title: title, onClick: onClickLink }, renderIcon));
    }
    else if (to) {
        iconContent = (React.createElement(Link, { to: to, className: cssContent, id: id, title: title, onClick: onClickLink }, renderIcon));
    }
    else {
        iconContent = (React.createElement("button", { type: 'button', id: id, className: cssContent, title: title, onClick: onClick, onMouseDown: (e) => e.preventDefault(), disabled: disabled }, renderIcon));
    }
    let css = classNames('button-icon-wrapper', className);
    return React.createElement("div", { className: css }, iconContent);
};
export { ButtonIcon };
//# sourceMappingURL=ButtonIcon.js.map